// @ts-strict-ignore
import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ElementRef,
  Inject,
  forwardRef,
  OnDestroy
} from '@angular/core';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMCtrlShiftClickEvent } from '@base/lm-ctrl-shift-click-event';
import { FormResource } from '@resources/form.resource';
import {
  LMActionRequest,
  LMActionService,
  LMComponentInfoService,
  LMContextService, LMErrorUtilService,
  LMUrlInfoBuilderService
} from '@services/index';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import { Observable, Subscription, throwError } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { ActionResource, DocumentResource, ListResource } from '@app/resources';
import { LMListComponent } from '@app/components';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component ({
  selector: 'lm-componentinfo',
  templateUrl: 'lm-componentinfo.component.html',
  styleUrls: ['lm-componentinfo.component.scss'],
  providers: [LMRouteComponentService],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class LMComponentInfoComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() info: LMComponentInfo;

  private subs$: Subscription = new Subscription();

  showListUrl = false;
  showReloadPageUrl = false;
  showFirstPageUrl = false;
  showNextPageUrl = false;
  showPreviousPageUrl = false;
  showLastPageUrl = false;
  showNextRecordUrl = false;
  showPreviousRecordUrl = false;
  showReloadRecordUrl = false;
  showActionRedirectUrl = false;
  showRelActionUrl = false;
  showFormRequestUrl = false;
  showLoadedUrl = false;
  showInputUrl = false;
  configureUrl: string;
  showDeveloper: boolean;
  showDebug: boolean;
  toggleOn = false;
  debugLevel = 'standard';
  dbSessionDebugResourceId = '';
  debugLimit = 'screen';

  private infoCache: LMComponentInfo;
  private busNameCache: string;
  private nameCache: string;
  public  debugName = '';
  public  listUrl = '';  // the url to show on open for a list

  contextFormExpanded?: boolean | undefined;
  private VIEW_EXCEPTION = 'com.lawson.rdtech.type.ViewException';
  private ALREADY_IN_USE = 'Name already in use';

  constructor(
    private elementRef: ElementRef,
    @Inject(forwardRef(() => LMRouteComponentService)) private currentComponent,
    private lmUrlUtilService: LMUrlUtilService,
    private lmNavigationService: LMNavigationService,
    private lmActionService: LMActionService,
    private lmcomponentinfoService: LMComponentInfoService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private lmContextService: LMContextService,
    private router: Router,
    private http: HttpClient,
    protected lmErrorUtilService: LMErrorUtilService,
  ) {}

  ngOnInit() {
    if (this.info.configInfo) {
      this.info.configInfo.personalization = this.info.configInfo && this.info.configInfo.personalization ? this.info.configInfo.personalization : false;
      this.info.configInfo.configuration = this.info.configInfo && this.info.configInfo.configuration ? this.info.configInfo.configuration : false;
    }
    if (this.info.componentType === 'LIST') {
      this.listUrl = this.lmUrlUtilService.updateUrlParams(this.info.listUrl, {select: ''} );
    }
    const routeUrlPathValues: LMPathValues = this.lmUrlUtilService.getUrlPathValues(this.router.url);

    const baseComponentId = routeUrlPathValues.name ? routeUrlPathValues.name : routeUrlPathValues.busClassName;
    this.debugName = routeUrlPathValues.name === this.info.name || this.info.name.indexOf(baseComponentId) >= 0 ? this.info.name : this.info.name + 'FROM' + baseComponentId;

    if (this.info.isDBSessionDebugActive) {
      this.initDBSessionDebugInfo();
    }
  }

  ngAfterViewInit() {
    $('.expandable-area').expandablearea()
      .on('expand', () => this.contextFormExpanded = true)
      .on('collapse', () => this.contextFormExpanded = false);
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }

  showHideListUrl() {
    this.showListUrl = !this.showListUrl;
    return false;
  }
  showHideReloadPageUrl() {
    this.showReloadPageUrl = !this.showReloadPageUrl;
    return false;
  }
  showHideFirstPageUrl() {
    this.showFirstPageUrl = !this.showFirstPageUrl;
    return false;
  }
  showHideNextPageUrl() {
    this.showNextPageUrl = !this.showNextPageUrl;
    return false;
  }
  showHidePreviousPageUrl() {
    this.showPreviousPageUrl = !this.showPreviousPageUrl;
    return false;
  }
  showHideLastPageUrl() {
    this.showLastPageUrl = !this.showLastPageUrl;
    return false;
  }
  showHideNextRecordUrl() {
    this.showNextRecordUrl = !this.showNextRecordUrl;
    return false;
  }
  showHidePreviousRecordUrl() {
    this.showPreviousRecordUrl = !this.showPreviousRecordUrl;
    return false;
  }
  showHideReloadRecordUrl() {
    this.showReloadRecordUrl = !this.showReloadRecordUrl;
    return false;
  }
  showHideActionRedirectUrl() {
    this.showActionRedirectUrl = !this.showActionRedirectUrl;
    return false;
  }
  showHideRelActionUrl() {
    this.showRelActionUrl = !this.showRelActionUrl;
    return false;
  }
  showHideFormRequestUrl() {
    this.showFormRequestUrl = !this.showFormRequestUrl;
    return false;
  }
  showHideLoadedUrl() {
    this.showLoadedUrl = !this.showLoadedUrl;
    return false;
  }
  showHideInputUrl() {
    this.showInputUrl = !this.showInputUrl;
    return false;
  }

  public openDebugger() {

    let url: string = this.info.componentType === 'LIST' ? this.listUrl : this.router.url;
    let currentList = '';
    if (this.info.formRequestUrl && this.info.formRequestUrl.length > 0) {
      url = this.getDebugUrl(url, this.info.formRequestUrl);
    }

    if (this.info.reloadPageUrl && this.info.reloadPageUrl.length > 0) {
      url = this.getDebugUrl(url, this.info.reloadPageUrl);
    }
    if (this.debugLimit === 'dataOnly') {
      url = url + (url.indexOf('?') ? '&' : '?') + 'pageop=load';
      this.debugName += 'DATA';
    }

    let debugUrl = url + (url.indexOf('?') ? '&' : '?') + "csk.dbsessiondebug=" + this.debugName + "&csk.dbsessiondebuglevel=" + this.debugLevel + (this.toggleOn ? '&csk.lpltrace=true' : '');

    if (this.debugLimit === 'dataOnly') {  // this.debugLimit === 'specOnly' ||
       this.http.get(debugUrl).subscribe((response: Response) => {
         const res = response as any;
         let dbSessionFormResource = this.getDBSessionResource([this.debugName]) ;
         if (this.isPage(debugUrl) && (Object.keys(res?.pageData?.dataView?.fields).length === 0 && !res?.pageData?.dataView.contextDataView)) {
           this.lmErrorUtilService.handleUnexpectedError({message: "Page Data", details:"No page level data found."});
         } else {
           let url = this.lmUrlUtilService.buildUrl({ resource: dbSessionFormResource, webApp: this.lmContextService.getWebApp() });
           this.lmUrlUtilService.openExternalUrl(url);
         }
       });
    } else {
      this.lmUrlUtilService.openExternalUrl(debugUrl);
    }
  }

  private handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
   // this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }

  private getDebugUrl(url: string, specialUrl: string) {
    const routeUrlPathValues: LMPathValues = this.lmUrlUtilService.getUrlPathValues(url);
    const specialUrlPathValues: LMPathValues = this.lmUrlUtilService.getUrlPathValues(specialUrl);
    if (routeUrlPathValues.resourceType !== specialUrlPathValues.resourceType
      || routeUrlPathValues.busClassName !== specialUrlPathValues.busClassName
      || routeUrlPathValues.name !== specialUrlPathValues.name )
    {
      this.debugName = this.info.name + 'FROM' + routeUrlPathValues.name;
      return this.info.formRequestUrl;
    }
    return url;
  }

  public openSecurityDebugger(): boolean {

    let debugUrl = this.router.url + (this.router.url.indexOf('?') ? '&' : '?') + "csk.secsessiondebug=true";
    this.lmUrlUtilService.openExternalUrl(debugUrl);
    this.closeDialog();
    return false;
  }

  public setDebugLevel(debugLevel: string) {
    this.debugLevel = debugLevel;
  }

  public setDebugLimit(debugLimit: string) {
    this.debugLimit = debugLimit;
  }

  public toggleTrace(trace: boolean) {
    this.toggleOn = trace;
  }

  public changeDebugID(debugId: string) {
    this.debugName = debugId;
  }

  closeDialog() {
    this.lmcomponentinfoService.closeDialog();
  }

  private isForm(url: string): boolean {
    return url.indexOf('/form/') > -1;
  }

  private isList(url: string): boolean {
    return url.indexOf('/list/') > -1;
  }

  private isPage(url: string): boolean {
    return url.indexOf('/page/') > -1;
  }

  showPageComponentInfo(event: LMCtrlShiftClickEvent) {

    //  let ctrlShiftClickEvent: CtrlShiftClickEvent = document.createEvent('CtrlShiftClickEvent') as CtrlShiftClickEvent;
    // csEvent.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, true, false, true, false, 0, null);
    //     document.body.dispatchEvent(event as Event);
    //   let ctrlShiftClickEvent: CtrlShiftClickEvent = csEvent as CtrlShiftClickEvent;
    // ctrlShiftClickEvent.srcEventElement = this.elementRef.nativeElement;
    const ctrlShiftClickEvent: LMCtrlShiftClickEvent = event as LMCtrlShiftClickEvent;
    ctrlShiftClickEvent.isPage = true;
    // ctrlShiftClickEvent.ctrlKey = true;
    // ctrlShiftClickEvent.metaKey = true;
    // ctrlShiftClickEvent.shiftKey = true;

    const pageComp: LMBaseComponent = this.info.routerComponent.currentComponent.getRouteComponent();

    // pageComp.displayComponentInfo(ctrlShiftClickEvent);
    pageComp.displayComponentInfo(ctrlShiftClickEvent, pageComp);
  }

  public toggleDeveloper() {
    this.showDeveloper = !this.showDeveloper;
  }

  public toggleDebugger() {
    this.showDebug = !this.showDebug;
  }

  public viewConfiguration(info: LMComponentInfo, busName: string, name: string) {
    if (!info) {
      info = this.infoCache;
      busName = this.busNameCache;
      name = this.nameCache;
    }
    if (info && info.panelType && info.panelType === 'form') {
      info.componentType = info.panelType.toUpperCase() as LMCompInfoType;
    }
    switch (info.componentType) {
      case 'FORM':
      case 'CONTEXT_FORM':
        this.modifyFormConfiguration(busName, name);
        break;
      case 'LIST':
        this.modifyListConfiguration(busName, name);
        break;
      case 'PAGE':
        this.modifyPageConfiguration(busName, name);
        break;
      case 'MENU':
        this.modifyMenuConfiguration(this.info.target);
        break;
      case 'CARDVIEW':
        this.modifyCardViewConfiguration(busName, name);
        break;
    }
  }

  public createConfiguration(info: LMComponentInfo, busName: string, name: string) {
    this.infoCache = info;
    this.busNameCache = busName;
    this.nameCache = name;

    if (info && info.panelType && info.panelType === 'form') {
      info.componentType = info.panelType.toUpperCase() as LMCompInfoType;
    }

    switch (info.componentType) {
      case 'FORM':
      case 'CONTEXT_FORM':
        this.createFormConfiguration(busName, name)
        break;
      case 'LIST':
        this.createListConfiguration(busName, name);
        break;
      case 'PAGE':
        this.createPageConfiguration(name);
        break;
      case 'MENU':
        this.createMenuConfiguration(this.info.target);
        break;
      case 'CARDVIEW':
        this.createCardViewConfiguration(busName, name);
        break;
    }
    this.closeDialog();
  }

  private createFormConfiguration(businessClass: string, formName: string) {
    const formResource = new FormResource({
      formName : 'CreateConfigurationForm',
      busClassName : 'UserForm'
    });
    const actionSpec: LMActionSpec = {
      type: 'CREATE',
      name: 'CreateConfiguration',
      hasParameters: true
    };
    const businessViewFld: LMField = {
      value: businessClass
    };
    const nameFld: LMField = {
      value: formName
    };
    const dataView: LMDataView = {
      action:       'CreateConfiguration',
      busClassName: 'UserForm',
      fields:       {BusinessView: businessViewFld, Form: nameFld}
    };
    this.runCreateConfiguration(formResource, actionSpec, dataView);
  }

  public upperCase(str: string): string {
    return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
  }

  public getAltFormUrl(url: string, altFormName: string) {
    const formInfo: LMFormUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromHttpUrl(url);
    const formResource: KeyedResource = formInfo.resource;
    formResource.uiResourceName = altFormName;

    // const urlOptions: URLOptions {
    //   resource: formResource,
    //   params?: any;
    //   webApp?: formInfo.;
    // }
    //
    //
    // this.lmUrlUtilService.buildUrl()
    // this.lminfobuilderserice
  }

  private modifyFormConfiguration(businessClass: string, formName: string) {
    const resourceKeys = [10, businessClass, formName, ];
    this.runModifyConfiguration(this.getModifyFormResource(resourceKeys));
  }

  private createListConfiguration(businessClass: string, listName: string) {
    const formResource = new FormResource({
      formName : 'CreateConfigurationForm',
      busClassName : 'UserList'
    });
    const actionSpec: LMActionSpec = {
      type:          'CREATE',
      name:          'CreateConfiguration',
      hasParameters: true
    };
    const businessViewFld: LMField = {
      value: businessClass
    };
    const nameFld: LMField = {
      value: listName
    };
    const dataView: LMDataView = {
      action:       'CreateConfiguration',
      busClassName: 'UserList',
      fields:       { BusinessView: businessViewFld, List: nameFld }
    };
    this.runCreateConfiguration(formResource, actionSpec, dataView);
  }

  private modifyListConfiguration(businessClass: string, listName: string) {
    const resourceKeys = [9, businessClass, listName, ];
    this.runModifyConfiguration(this.getModifyFormResource(resourceKeys));
  }

  private createPageConfiguration(pageName: string) {
    const formResource = new FormResource({
      formName : 'CreateConfigurationForm',
      busClassName : 'UserPage'
    });
    const actionSpec: LMActionSpec = {
      type:          'CREATE',
      name:          'CreateConfiguration',
      hasParameters: true
    };
    const nameFld: LMField = {
      value: pageName
    };
    const dataView: LMDataView = {
      action:       'CreateConfiguration',
      busClassName: 'UserPage',
      fields:       { Page: nameFld }
    };
    this.runCreateConfiguration(formResource, actionSpec, dataView);
  }

  private modifyPageConfiguration(businessClass: string, pageName: string) {
    const resourceKeys = [12, '', pageName, ];
    this.runModifyConfiguration(this.getModifyFormResource(resourceKeys));
  }

  private createCardViewConfiguration(businessClass: string, cardName: string) {
    const formResource = new FormResource({
      formName : 'CreateConfigurationForm',
      busClassName : 'UserCardView'
    });
    const actionSpec: LMActionSpec = {
      type:          'CREATE',
      name:          'CreateConfiguration',
      hasParameters: true
    };
    const businessViewFld: LMField = {
      value: businessClass
    };
    const nameFld: LMField = {
      value: cardName
    };
    const dataView: LMDataView = {
      action:       'CreateConfiguration',
      busClassName: 'UserCardView',
      fields:       { BusinessView: businessViewFld, Card: nameFld }
    };
    this.runCreateConfiguration(formResource, actionSpec, dataView);
  }

  private modifyCardViewConfiguration(businessClass: string, listName: string) {
    const resourceKeys = [18, businessClass, listName, ];
    this.runModifyConfiguration(this.getModifyFormResource(resourceKeys));
  }

  private createMenuConfiguration(menuName: string) {
    const formResource = new FormResource({
      formName : 'CreateConfigurationForm',
      busClassName : 'UserMenu'
    });
    const actionSpec: LMActionSpec = {
      type:          'CREATE',
      name:          'CreateConfiguration',
      hasParameters: true
    };
    const nameFld: LMField = {
      value: menuName
    };
    const dataView: LMDataView = {
      action:       'CreateConfiguration',
      busClassName: 'UserMenu',
      fields:       { Menu: nameFld }
    };
    this.runCreateConfiguration(formResource, actionSpec, dataView);
  }

  private modifyMenuConfiguration(nemuName: string) {
    const resourceKeys = [11, '', nemuName, ];
    this.runModifyConfiguration(this.getModifyFormResource(resourceKeys));
  }

  private runCreateConfiguration(formResource: FormResource, actionSpec: LMActionSpec, dataView: LMDataView) {
    const url = this.lmUrlUtilService.buildUrl({resource: formResource, webApp: 'ConfigurationConsole'});
    const actionRequest: LMActionRequest = {
      dataView,
      actionSpec
    };
    const args = {
      url,
      actionRequestArray: [actionRequest]
    };
  //  this.subs$.add(
      this.lmActionService.makeExecute(args).subscribe((response: any) => {
        if (response.status !== undefined) {
          if (this.alreadyExists(response[0]) || this.nameAlreadyInUse(response[0])) {
            // If it already exist attempt to launch modify.
            this.viewConfiguration (this.infoCache, this.busNameCache, this.nameCache);
          }

        } else {
          const result: LMActionResult = response[ 0 ];
          if (result.isCompletionNavigation && result.redirectUrl) {
            this.lmNavigationService.runNavigation(result.redirectUrl, undefined, { openNewTab: true });
          } else if (result.status === 'VIEW_EXCEPTION') {
            if (this.alreadyExists(response[0]) || this.nameAlreadyInUse(response[0])) {
              // If it already exist attempt to launch modify.
              this.viewConfiguration (this.infoCache, this.busNameCache, this.nameCache);
            }
          }
        }
      },
      (error: any) => throwError(error || 'Unable to open Configuration Console'));
  //  );
  }

  private getDBSessionResource(resourceKeys: any): FormResource {
    return new FormResource({
      formName : 'DBSessionDebugCompositeForm',
      busClassName : 'DBSessionDebug',
      viewKeyName : 'BySessionId',
      keyValueArray: resourceKeys
    });
  }

  private runModifyConfiguration(formResource: FormResource) {
    const url = this.lmUrlUtilService.buildUrl({resource: formResource, webApp: 'ConfigurationConsole'});
    this.lmUrlUtilService.openExternalUrl(url);
    this.closeDialog();
  }

  private getModifyFormResource(resourceKeys: any): FormResource {
    return new FormResource({
      formName : 'ConsoleDetailForm',
      busClassName : 'ConfigEntity',
      viewKeyName : 'ByEntityType',
      keyValueArray: resourceKeys
    });
  }

  private alreadyExists(response: any): boolean {
    return (response && response.details
            && response.details.indexOf(this.VIEW_EXCEPTION) >= 0);
  }

  private nameAlreadyInUse(response: any): boolean {
    return (response && response.details && response.details.indexOf(this.ALREADY_IN_USE) >= 0);
  }

  public runViewBaseLpl(info: LMComponentInfo, busName: string, name: string) {
    let resourceKeys: any = [""];
    let busClassName: string = "";

    if (info && info.panelType && info.panelType === 'form') {
      info.componentType = info.panelType.toUpperCase() as LMCompInfoType;
    }

    switch (info.componentType) {
      case 'FORM':
      case 'CONTEXT_FORM':
        busClassName = "BusinessForm";
        resourceKeys = [busName, name];
        break;
      case 'LIST':
        busClassName = "BusinessList";
        resourceKeys = [busName, name];
        break;
      case 'PAGE':
        busClassName = "BusinessPage";
        resourceKeys = [name];
        break;
      case 'MENU':
        busClassName = "BusinessMenu";
        resourceKeys = [name];
        break;
      case 'CARDVIEW':
        busClassName = "BusinessCardView";
        resourceKeys = [busName, name];
        break;
    }

   const formResource: FormResource = new FormResource({
      formName : 'LPLViewerForm',
      busClassName : busClassName,
      keyValueArray: resourceKeys
    });

    const url = this.lmUrlUtilService.buildUrl({resource: formResource, webApp: 'ConfigurationConsole'});
    this.lmUrlUtilService.openExternalUrl(url);
    this.closeDialog();
  }

  public runViewBusinessLogic(info: LMComponentInfo, busName: string, name: string) {
    const resourceKeys = [busName];

    const formResource: FormResource = new FormResource({
      formName : 'LPLViewerForm',
      busClassName : 'BusinessView',
      keyValueArray: resourceKeys
    });

    const url = this.lmUrlUtilService.buildUrl({resource: formResource, webApp: 'ConfigurationConsole'});
    this.lmUrlUtilService.openExternalUrl(url);
    this.closeDialog();
  }

  public onViewDBSessionDebugResult(): void {
    const actionResource: ActionResource = new ActionResource({
      resourceId: this.dbSessionDebugResourceId,
      actionName: '_open'
    });

    let url = this.lmUrlUtilService.buildUrl({ resource: actionResource, webApp: 'ConfigurationConsole' });
    url = this.lmUrlUtilService.updateUrlParams(url, { 'csk.dbsessiondebug': undefined, 'csk.dbsessiondebuglevel': undefined, 'csk.lpltrace': undefined });
    this.lmUrlUtilService.openExternalUrl(url);
    this.closeDialog();
  }

  public onDownloadDBSessionDebugResult(): void {
    const documentResource: DocumentResource = new DocumentResource({
      resourceId: this.dbSessionDebugResourceId,
      fieldName: '_op_SessionDebugZipDefault_spc_translation_cp_'
    }, "");

    const params = {
      action: 'Share'
    };

    let url = this.lmUrlUtilService.buildUrl({ resource: documentResource, webApp: 'ConfigurationConsole', params });
    url = this.lmUrlUtilService.updateUrlParams(url, { 'csk.dbsessiondebug': undefined, 'csk.dbsessiondebuglevel': undefined, 'csk.lpltrace': undefined });
    this.lmUrlUtilService.openExternalUrl(url);
    this.closeDialog();
  }

  private initDBSessionDebugInfo(): void {
    const listResource: ListResource = new ListResource({
      listName : 'DBSessionDebugList',
      busClassName : 'DBSessionDebug'
    });

    const params = {
      pageop: 'filter',
      pagesize: 1,
      'fc.SessionId': `equals(${this.info.dbSessionId})`
    };

    const url = this.lmUrlUtilService.buildUrl({ resource: listResource, webApp: 'ConfigurationConsole', params });
    
    this.subs$.add(
      this.lmNavigationService.getActionNavigationUrl(url).subscribe(response => {
        const res = response as LMListPagingResponse;
        this.dbSessionDebugResourceId = res?.dataViewSet?.data?.[0]?.resourceId;
      })
    );
  }
}
